module.exports = __webpack_public_path__ + "static/media/kocka3IUG.600a7d82.png";